import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  WikiPages,
  WikiPagesEdit,
  WikiPageDetail,
  WikiCategories,
  WikiCategoriesEdit,
} from '../pages/CMSPages/index';
import React from "react";

const WikiRoutes = () => (
  <>
    <Route
      path={routes.cmsWikiPages}
      element={
        <CMSWrapper permissions={['wiki-pages.index']}>
          <WikiPages />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsWikiPageCreate}
      element={
        <CMSWrapper permissions={['wiki-pages.store']}>
          <WikiPagesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsWikiPageEdit}/:id`}
      element={
        <CMSWrapper permissions={['wiki-pages.update']}>
          <WikiPagesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsWikiPageDetail}/:id`}
      element={
        <CMSWrapper permissions={['wiki-pages.show']}>
          <WikiPageDetail />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsWikiCategories}
      element={
        <CMSWrapper permissions={['wiki-categories.index']}>
          <WikiCategories />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsWikiCategoryCreate}
      element={
        <CMSWrapper permissions={['wiki-categories.store']}>
          <WikiCategoriesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsWikiCategoryEdit}/:id`}
      element={
        <CMSWrapper permissions={['wiki-categories.update']}>
          <WikiCategoriesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
  </>
);

export default WikiRoutes;
